import { SwipeableDrawer } from '@mui/material';
import { styled } from '@mui/material/styles';

import { OPENED_DRAWER_WIDTH } from 'layout/MainLayout/components/Sidebar/constants';

const drawerBorderRadius = '0 16px 16px 0';

export const MobileDrawer = styled(SwipeableDrawer)({
  width: OPENED_DRAWER_WIDTH,
  borderRadius: drawerBorderRadius,
  '& .MuiDrawer-paper': {
    display: 'grid',
    gridTemplateRows: 'max-content max-content auto max-content',
    width: OPENED_DRAWER_WIDTH,
    borderRadius: drawerBorderRadius,
  },
});
